import { Injectable } from "@angular/core";
import { DatePipe } from "@angular/common";

@Injectable({
    providedIn: "root",
})
export class HelpersService {
    constructor(public datepipe: DatePipe) {}

    convertDateToDDMMYYY(date: Date): string {
        const fecha = new Date(date);
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const anio = fecha.getFullYear();
        return `${dia}/${mes}/${anio}`;
    }

    convertDateToYYMMDD(date: string): string {
        const latest_date = date.split("/");

        return latest_date[2] + latest_date[1] + latest_date[0];
    }
    convertDateToDDMMYYYString(date: string): string {
        const latest_date = date.split("-");

        return latest_date[2] + "/" + latest_date[1] + "/" + latest_date[0];
    }
    DateNowInputString() {
        const date = new Date();
        const year = date.getFullYear();

        let month: number | string = date.getMonth() + 1;
        let day: number | string = date.getDate();

        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        let today = `${year}-${month}-${day}`;
        return today;
    }
    DateInput(date: Date) {
        const year = date.getFullYear();

        let month: number | string = date.getMonth() + 1;
        let day: number | string = date.getDate();

        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        let today = `${year}-${month}-${day}`;
        console.log("todar", today);
        return today;
    }

    toCOPcurrency(value?: number): string {
        if (value == null) return "$ 0";

        const formatter = new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });

        return formatter.format(value);
    }

    convertJulianasToGregorianas(julianas: number): string {
        const baseDate = new Date(Date.UTC(1800, 11, 28));
        baseDate.setUTCDate(baseDate.getUTCDate() + julianas);
        const year = baseDate.getUTCFullYear();
        const month = baseDate.getUTCMonth() + 1;
        const day = baseDate.getUTCDate();

        return `${day}/${month}/${year}`;
    }

    convertGregorianasToJulianas(day: number, month: number, year: number): number {
        const baseDate = new Date(Date.UTC(1800, 11, 28));
        const targetDate = new Date(Date.UTC(year, month - 1, day));
        const diffTime = targetDate.getTime() - baseDate.getTime();
        const julianas = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return julianas;
    }

    getTodayInJulianas(): number {
        const baseDate = new Date(Date.UTC(1800, 11, 28));
        const today = new Date();
        const todayUTC = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
        const diffTime = todayUTC.getTime() - baseDate.getTime();
        const julianas = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return julianas;
    }
}
